import React, { useEffect, useState } from "react";
import DropPercentageChart from "../style/images/drop_percentage_chart.svg";

export const LocationPercentageChart = ({ target_name, data }) => {
  // console.log(data)
  const [svg, setSvg] = useState(null);

  useEffect(() => {
    fetch(DropPercentageChart)
      .then((response) => response.text())
      .then((text) => {
        // Use a DOM parser to create a document from the SVG text
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, "image/svg+xml");

        // Get the SVG element from the document
        const svgElement = doc.querySelector("svg");

        // Set the padding style for the SVG element
        svgElement.style.padding = "1vw";

        // Get the title elements from the SVG element
        const titleElement = svgElement.querySelector("#svg_title");
        const titleElement1 = svgElement.querySelector("#svg_title1");
        const titleElement2 = svgElement.querySelector("#svg_title2");

        // Split the data title by "|"
        const title_tmp = data.title.split("|");

        // Set the text content for the title elements based on the data title
        if (title_tmp.length === 1) {
          titleElement.textContent = title_tmp[0];
        } else {
          titleElement1.textContent = title_tmp[0];
          titleElement2.textContent = title_tmp[1];
        }

        // Loop through the data values
        for (let i = 0; i < data.values.length; i++) {
          // Get the area and text elements from the SVG element by their IDs
          const areaElement = svgElement.querySelector(`#svg_area${i + 1}`);
          const textElement = svgElement.querySelector(
            `#svg_area${i + 1}_text`
          );

          // Set the class name for the area element based on the data value
          let className;
          if (data.values[i] < 5) {
            className = "svg_level1";
          } else if (data.values[i] >= 5 && data.values[i] < 10) {
            className = "svg_level2";
          } else if (data.values[i] >= 10 && data.values[i] < 15) {
            className = "svg_level3";
          } else if (data.values[i] >= 15 && data.values[i] < 20) {
            className = "svg_level4";
          } else if (data.values[i] >= 20) {
            className = "svg_level5";
          }
          areaElement.classList.add(className);

          // Set the text content for the text element based on the data value
          textElement.textContent = data.values[i];
        }

        // Convert the SVG element back to a string
        const serializer = new XMLSerializer();
        const svgString = serializer.serializeToString(svgElement);

        // Set the state with the modified SVG string
        setSvg(svgString);
      });
  }, [data]);

  if (!svg) return null;

  // Use the dangerouslySetInnerHTML prop to render the SVG string as HTML
  return (
    <div className="drop_area" name={target_name}>
      <div dangerouslySetInnerHTML={{ __html: svg }} />
    </div>
  );
}